import { TAB } from '../constants';

export function getPlaceholder(tab) {
    switch (tab) {
        case TAB.PLAN:
            return 'insurance plan';
        case TAB.BCBS:
            return 'insurance carrier';
        default:
            return 'insurance carrier and plan';
    }
}
